var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"land-home-carousel"},[_c('div',{staticStyle:{"width":"1200px","margin":"0 auto"}},[_c('div',{staticClass:"solution-banner-title"},[_vm._v("NEWS")]),_c('div',{staticClass:"solution-banner-text"},[_vm._v("动态")])])])])
}]

export { render, staticRenderFns }